import { useEffect } from 'react';
import I18n from 'I18n';
import Raven from 'raven-js';
import enviro from 'enviro';
import { URLServiceComponent } from '../OAuthIntegrations/URLServiceComponent';
import { useTrelloRedirectUrl } from '../../hooks/useTrelloRedirectUrl';
import * as TrelloApi from './TrelloApi';
import { jsx as _jsx } from "react/jsx-runtime";
export const TrelloServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthFailed,
  onAuthSucceeded,
  reconnectStarted,
  timeout
}) => {
  const {
    redirectUrl,
    error: redirectUrlError,
    loading: redirectUrlLoading
  } = useTrelloRedirectUrl({
    skip: !reconnectStarted
  });
  useEffect(() => {
    if (redirectUrlError) {
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: redirectUrlError,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed')
      });
    }
  }, [redirectUrlError, onAuthFailed]);
  const handleAuthSucceeded = code => {
    void TrelloApi.installTrello(code).then(() => {
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
    }).catch(err => {
      if (!enviro.deployed()) {
        console.error(err);
      }
      Raven.captureException(err, {
        extra: {
          message: 'Error on authentication of Trello'
        }
      });
      onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed({
        error: err,
        errorMessage: I18n.text('reconnect.errors.reconnectFailed')
      });
    });
  };
  if (redirectUrlError || !redirectUrl) {
    return null;
  }
  return reconnectStarted && !redirectUrlLoading ? /*#__PURE__*/_jsx(URLServiceComponent, {
    metadata: metadata,
    onAuthSucceeded: handleAuthSucceeded,
    onAuthCancelled: onAuthCancelled,
    onAuthFailed: onAuthFailed,
    reconnectStarted: reconnectStarted,
    timeout: timeout,
    url: redirectUrl
  }) : null;
};